<template>
  <div class="container">
    <div class="operateBtn">
      <router-link to="/drivingLicense"><div>车证预约</div></router-link>
      <router-link to="/viewOrder"><div>查看预约</div></router-link>
      <a @click="clickImg">行车路线</a>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import { getShareData } from "@/utils/share";
export default {
  name: "expoCar",
  components: {
    "van-image-preview": ImagePreview,
  },

  data() {
    return {};
  },

  methods: {
    //点击行车路线
    clickImg() {
      ImagePreview({
        images: ["https://files.alighting.com/Cover/carRound.jpg"],
        showIndex: false,
      });
    },
  },

  mounted() {
    getShareData(
      window.location.href,
      "申请展品筹撤展车证（2022光亚展）",
      "2022广州国际照明展览会+广州国际建筑电气技术及智能家居展览会申请车证通道",
      "https://files.alighting.com/preRegistration/car.jpg"
    );
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 375px;
  height: 100vh;
  background-image: url("https://files.alighting.com/preRegistration/applycar.png");
  background-size: 100% auto;
  .operateBtn {
    position: absolute;
    top: 300px;
    left: 50%;
    transform: translate(-50%, 0);
    a {
      display: block;
      width: 275px;
      height: 45px;
      line-height: 45px;
      background: #eb4e4e;
      border-radius: 22px;
      font-size: 18px;
      color: #fff;
      text-align: center;
      margin-bottom: 25px;
      color: #fff;
      div {
        color: #fff;
      }
    }
  }
}
</style>